import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-new-employee-job-offer",
  templateUrl: "./new-employee-job-offer.component.html",
  styleUrls: ["./new-employee-job-offer.component.scss"],
})
export class NewEmployeeJobOfferComponent implements OnInit {
  jobOfferData: any = [];
  apisub: Subscription;
  constructor(
    private _router: Router,
    private activemodal: MatDialogRef<NewEmployeeJobOfferComponent>,
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private _modelRef: MatDialog,
    private loaderService: LoaderServiceService,
    private _apiService: ApiService
  ) {
    this.apisub = this._apiService.apiResult.subscribe((resdata) => {
      if (resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_AS_EMPLOYEE) {
        if (resdata.result) {
          resdata.result =
            typeof resdata.result == "string"
              ? JSON.parse(resdata.result)
              : resdata.result;
          if (this.statusOfChange == 1) {
            let data = {
              subscriptionInfo: {
                employee_hash_id: resdata.result.employee_hash_id,
              },
            };
            this._apiService.updateUserSubsciptionInfo(
              this.selectedOffer.subscriptionHash,
              data
            );
          } else if (this.statusOfChange == 2) {
            this._apiService.getJobInvitations(
              localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
              localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE),
              localStorage.getItem(SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER),
              "1"
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_USER_SUBSCRIPTION_INFO
      ) {
        if (resdata.result) {
          this.loaderService.showLoader = false;
          this.activemodal.close()
          this._apiService.getBasicEntityList()
          this._router.navigate(["employees-profile"]);
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_JOB_INVITATIONS
      ) {
        this.jobOfferData = [];
        if (resdata.result) {
          this.jobOfferData = resdata.result;
          this.jobOfferData.forEach((element: any) => {
            element.entityInfo =
              typeof element.entityInfo == "string"
                ? JSON.parse(element.entityInfo)
                : element.entityInfo;
          });
          this.loaderService.showLoader = false;
        } else {
          this.loaderService.showLoader = false;
          this.activemodal.close();
        }
      }
    });
  }

  ngOnInit(): void {
    console.log(this.parentdata);
    if (this.parentdata.jobOfferData) {
      this.jobOfferData = this.parentdata.jobOfferData;
      this.jobOfferData.forEach((element: any) => {
        element.entityInfo =
          typeof element.entityInfo == "string"
            ? JSON.parse(element.entityInfo)
            : element.entityInfo;
      });
    }
  }

  statusOfChange: any;
  selectedOffer: any;
  setAcceptanceStatus(status: any, offer: any) {
    this.statusOfChange = status;
    this.selectedOffer = offer;

    // ACCEPTED : 1 -> then redirect to employee profile

    // DENIED : 2 -> then refresh the list

    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message:
          "Are you sure you want to " +
          (this.statusOfChange == 2 ? "deny" : "accept") +
          " this job offer?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          isAccept: this.statusOfChange,
        };
        this.loaderService.showLoader = true;
        this._apiService.addAsEmployee(offer.requestHashId, data);
      }
    });
  }
}
